import { useAuth } from '../contexts/AuthContext.jsx'

export default function Header() {
  const { isAuthenticated, logout } = useAuth()

  return (
    <header>
      <h1>Truco Acessível</h1>
      <nav id="main-nav" aria-label="Navegação principal">
        {isAuthenticated && (
          <button
            id="btn-logout"
            type="button"
            className="btn btn-secondary"
            onClick={logout}
          >
            Sair da conta
          </button>
        )}
      </nav>
    </header>
  )
}
